import { useTranslation } from 'react-i18next'
import { Main } from '../../components'
import Card from '../../components/Card'
import { useCustomDomain } from '../../hooks/useCustomDomain'
import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { usePageInfo } from '../../config/queries'
import { gameVersionToSubdomain } from 'app/frontend/types/custom/GameVersion'

const InactiveDomain = () => {
  const { t } = useTranslation()
  const {
    data: { gameVersion },
  } = usePageInfo()
  const { customDomain } = useCustomDomain()

  return (
    <Main>
      <Card className='text-center mt-16 max-w-xl mx-auto'>
        <h3>{t('errors.custom_domain.inactive')}</h3>
        <p>{t('errors.custom_domain.inactive_description')}</p>

        <a
          href={`https://${gameVersionToSubdomain[gameVersion]}wowaudit.com${
            (customDomain?.team || customDomain?.guild)?.basePath
          }`}
          className={cn(buttonVariants({ variant: 'default' }), 'mt-4')}
        >
          {t('errors.custom_domain.view_on_main_website')}
        </a>
      </Card>
    </Main>
  )
}

export default InactiveDomain
